import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';


//css NavBar.css 

const PopupForm = ({handlePopXClick}) => {

let urlsGet = window.location.href;
  
  const [errors, setError] = useState({});
  const [formData, setFormData] = useState({
      name: '',
      mobile: '',
      email: '',
      location: '',
      message: '',
      pageUrl: urlsGet,
  });

  const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const website_name = 'Corporate Planner';
const indiaDateTime = new Date().toLocaleString('en-IN', {
  timeZone: 'Asia/Kolkata',
  hour12: false,            
  weekday: 'long',         
  year: 'numeric',          
  month: 'long',        
  day: 'numeric',       
  hour: '2-digit',         
  minute: '2-digit',       
  second: '2-digit'   
});

const formattedDateTime = indiaDateTime.replace(/,/g, ''); 

let contact = '';
if (formData['name'] !== '') contact += `Name:-${formData['name']}, `;
if (formData['mobile'] !== '') contact += `Mobile:-${formData['mobile']}, `;
if (formData['email'] !== '') contact += `Email:-${formData['email']}, `;
if (formData['location'] !== '') contact += `Location:-${formData['location']}, `;
if (urlsGet !== '') contact += `Url:-${urlsGet}, `;
contact += `Date:-${formattedDateTime}`;
const messages = formData['message'];

const payload = {
  website_name: website_name,
  contact: contact,
  message: messages
};
const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
      e.preventDefault();
      console.log(payload)
      setIsLoading(true);
      try {
          const result = await axios.post('https://leads.hotelstourandtravel.com/api/cyj-leads-insert', payload);
          Swal.fire(result.data.message).then(()=>{
            window.location.reload();
          });
      } catch (error) {
        console.log(error)
        setError(error.response.data);
        setIsLoading(false);
      }
  };



    return (
        <div className="sendquerybox">
            <div className="innersendquery">


                <i className="fa-solid fa-x popx" onClick={handlePopXClick}></i>

                <div className="formimgbx">
                    <img src="image/carton.png" alt="from" />
                </div>
                <form className='popupformbx formslidef' onSubmit={handleSubmit}>
                    <h2>Get in Touch with Us</h2>
                    <p>Plan Your Escape with Us!</p>
                    <div className="forminputfield">
                        <i className="fa-solid fa-user"></i>
                        <input type="text" name="name" value={formData.name} placeholder="Name" onChange={handleChange} />
                    </div>
                    <p style={{ color: 'red', fontSize: '.7rem', }}>{errors.name}</p>
                    <div className="forminputfield">
                        <i className="fa-solid fa-phone"></i>
                        <input type="text" name="mobile"  value={formData.mobile} placeholder="Mobile" onChange={handleChange} />
                    </div>
                    <p style={{ color: 'red', fontSize: '.7rem', }}>{errors.mobile}</p>
                    <div className="forminputfield">
                        <i className="fa-solid fa-envelope"></i>
                        <input type="email" name="email" value={formData.email} placeholder="Email" onChange={handleChange} />
                    </div>
                    <p style={{ color: 'red', fontSize: '.7rem', }}>{errors.email}</p>
                    <div className="forminputfield">
                        <i className="fa-solid fa-map"></i>
                        <input type="text" name="location" value={formData.location} placeholder="Location" onChange={handleChange} />
                    </div>
                    <p style={{ color: 'red', fontSize: '.7rem', }}>{errors.location}</p>
                    <div className="forminputfield">
                        <i className="fa-solid fa-pen penicon"></i>
                        <textarea placeholder="Message here..." name="message" value={formData.message} onChange={handleChange} />
                    </div>
                    <button>{isLoading ? "Sending..." : "Submit"}</button>
                </form>
            </div>

        </div>
    )
}

export default PopupForm
